import { CREATE_UPLOAD_TICKET, CREATE_UPLOAD_TICKET_SUCCESS, CREATE_UPLOAD_TICKET_ERROR, CREATE_UPLOAD_TICKET_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateUploadTicket = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_UPLOAD_TICKET:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_UPLOAD_TICKET_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_UPLOAD_TICKET_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_UPLOAD_TICKET_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateUploadTicket;
